/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_End_SaveInputs */

const en_us2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save choices`)
};

const pt_br2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar escolhas`)
};

const es_419_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar elecciones`)
};

const pt_pt2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar escolhas`)
};

const fr_fr2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_de2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl speichern`)
};

const it_it2_workout_swap_end_save = /** @type {(inputs: Workout_Swap_End_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva scelte`)
};

/**
* | output |
* | --- |
* | "Save choices" |
*
* @param {Workout_Swap_End_SaveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_end_save = /** @type {((inputs?: Workout_Swap_End_SaveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_End_SaveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_end_save(inputs)
	if (locale === "es-419") return es_419_workout_swap_end_save(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_end_save(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_end_save(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_end_save(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_end_save(inputs)
	return en_us2_workout_swap_end_save(inputs)
});
export { workout_swap_end_save as "workout-swap.end_save" }